var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShowMoreArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 7,
    viewBox: "0 0 11 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.41333 0L5.33333 4.07111L1.25333 0L0 1.25333L5.33333 6.58667L10.6667 1.25333L9.41333 0Z",
    fill: "#004895"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowMoreArrow);
export default __webpack_public_path__ + "static/media/ShowMoreArrow.20a11a775aad48d02773a02cd42b4265.svg";
export { ForwardRef as ReactComponent };